export default __webpack_public_path__ + "static/media/Paypal.b8430a49.svg";